(function() {
  define('bazemont/newsflash/newsflash',['angular'], function() {
    'use strict';
    return angular.module('bazemontNewsflash', []).component('bazemontNewsflash', {
      templateUrl: '/assets/javascripts/bazemont/newsflash/newsflash.html',
      controller: [
        '$scope', 'Newsflash', 'TlhNotifierService', 'TlhCmsEvents', 'TlhNotificationService', function($scope, Newsflash, TlhNotifierService, TlhCmsEvents, TlhNotificationService) {
          var cancel, edited, handleChange, initialValue, save, toolbarButtons, vm;
          vm = this;
          edited = false;
          initialValue = null;
          vm.$onInit = function() {
            return Newsflash.get({}, function(result) {
              initialValue = result;
              return vm.newsflash = angular.copy(initialValue);
            });
          };
          toolbarButtons = ['bold', 'italic', 'underline', 'strikeThrough', '|', 'formatOL', 'formatUL', 'insertLink', 'insertFile', '-', 'undo', 'redo', 'clearFormatting', 'selectAll'];
          vm.editorConfig = {
            toolbarInline: true,
            pluginsEnabled: ['file', 'lineBreaker', 'link', 'lists', 'url'],
            toolbarButtons: toolbarButtons
          };
          vm.empty = function() {
            return vm.newsflash.content = '';
          };
          save = function() {
            if (vm.newsflash !== initialValue) {
              TlhNotificationService.info({
                message: 'Enregistrement du flash info en cours...',
                delay: false
              });
              return new Newsflash(vm.newsflash).$save().then(function(response) {
                initialValue = angular.copy(response);
                vm.newsflash = angular.copy(initialValue);
                TlhNotifierService.send(TlhCmsEvents.SAVE_SUCCESS);
                return TlhNotificationService.success({
                  message: 'Enregistrement du flash info terminé',
                  replaceMessage: true
                });
              })["catch"](function(error) {
                var message;
                message = "L'enregistrement a échoué :<br>";
                message += error.data ? error.data : "Erreur inattendue lors de l'enregistrement du flash info. Veuillez contacter l'administrateur.";
                TlhNotifierService.send(TlhCmsEvents.SAVE_FAILED);
                TlhNotificationService.error({
                  message: message,
                  replaceMessage: true,
                  delay: false
                });
                return console.error(error);
              });
            }
          };
          cancel = function() {
            return vm.newsflash = angular.copy(initialValue);
          };
          handleChange = function(newValue, oldValue) {
            if (newValue !== oldValue) {
              if (!edited && !angular.equals(newValue, initialValue)) {
                TlhNotifierService.send(TlhCmsEvents.PAGE_MODIFIED);
                edited = true;
              }
              if (edited && angular.equals(newValue, initialValue)) {
                TlhNotifierService.send(TlhCmsEvents.PAGE_UNMODIFIED);
                return edited = false;
              }
            }
          };
          $scope.$on(TlhCmsEvents.SAVE_ALL, save);
          $scope.$on(TlhCmsEvents.CANCEL_ALL, cancel);
          $scope.$watch(function() {
            return vm.newsflash;
          }, handleChange, true);
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=newsflash.js.map
;
